module.exports = {
    language: {
        name: '中文',
        code: 'zh'
    },
    menu: {
        title: 'CAA Paper'
    },
    login: {
        user: {
            blur: 'Login With Ordinary User',
            title: 'User'
        },
        chair: {
            blur: 'Login With Chair Or Cochair',
            title: 'Chair'
        },
        title: 'Login',
        dashboard: 'Dashboard',
        message: 'You Did Not Login, Please Choose Login Identity',
        email: 'Email Or LoginName',
        password: 'Password',
        rule: {
            userEmail: 'Please input email',
            password: 'Please input password'
        },
        jumpNow:'Go to 2025 System',
        jumpCancel: 'Stay Here',
        loginMsg1:'You are currently visiting the {year} China Automation Congress (CAC) Submission System.',
        loginMsg2:'Would you like to go to the 2025 China Automation Congress (CAC) Submission System?'
    },
    header: {
        profile: 'Profile',
        rePwd: 'Reset password',
        switchRole: 'Switch role',
        logout: 'Logout',
        userName: 'User Name',
        email: 'Email',
        password: 'Password',
        passwordConfirm: 'Password Confirm',
        rule: {
            adminName: 'Please input user name',
            password: 'Please input password',
            passwordConfirm: 'Please input confirm password',
            passwordNotEqual: 'Confirm password is not equal to password',
            email: 'Please input email'
        }
    },
    button: {
        posterType: 'Presentation Type',
        ResetPoster: 'Reset Poster',
        posterArrange: 'Poster arrangement',
        poster: 'Poster',
        oral: 'Oral',
        online: 'online',
        offline: 'offline',
        close: 'close',
        closeDlg: 'close',
        unwind: 'Re-sign',
        GoSigning: 'Go to sign',
        copyrightSubmission: 'Copyright Submission',
        importMessage: 'Please upload reviewerImportTemplate!',
        inviteMessage: 'Please upload reviewerInviteTemplate!',
        reviewerImportTemplate: 'reviewerImportTemplate',
        reviewerImport: 'reviewerImport',
        reviewerInviteTemplate: 'reviewerInviteTemplate',
        reviewerInvite: 'reviewerInvite',
        print: 'Print',
        back: 'Back',
        query: 'Query',
        create: 'Create',
        download: 'Download',
        downloadTemplate: 'Download your exclusive template',
        downloadCertificate: 'Download Certificate',
        submit: 'Submit',
        reset: 'Reset',
        cancel: 'Cancel',
        cochair: 'Cochair',
        reviewer: 'Reviewer',
        batchReviewer: 'Batch Reviewer',
        review: 'Review',
        register: 'Register',
        finalConfirm: 'FinalSubmit',
        copyright: 'copyright',
        chooseSession: 'Choose Session',
        detail: 'Detail',
        detailBack: 'Return',
        judge: 'Judge',
        delete: 'Delete',
        edit: 'Edit',
        paperSet: 'Set',
        finalSubmit: 'FinalSubmit',
        template: 'Template',
        import: 'Import',
        revoke: 'Revoke',
        insert: 'Submit',
        upload: {
            text: 'Drag the file here or click Upload',
            tip: 'Only pdf files can be uploaded and no more than 200MB (If there is no update, no re-upload )',
            tipDoc: 'Only pdf、doc、docx files can be uploaded and no more than 200MB (If there is no update, no re-upload )',
            tipZip: 'Only pdf、rar、zip files can be uploaded and no more than 200MB (If there is no update, no re-upload )',
        },
        rechecking:{
            send:'发送提醒',
            downloadTemplate:'下载模版',
            upTemplate:'导入查重结果',
            upTemplate2:'导入查重报告',
            checkingResult:'查重结果',
            download:'下载论文',
            viewRepord:'查看报告',
        }
    },
    rechecking:{
        duplicateRate:'查重率',
        duplicateFile:'报告',
        duplicateTag:'Plagiarism Check',//'查重结果',
        submitUserName:'作者',
        submitUserPhone:'手机号',
        submitUserEmail:'邮箱',
        paperStatus:'论文状态',
// 通过：Pass
// 未通过：Fail
// 待查重：Awaiting Check
        pass:'Pass',
        noPass:'Fail',
        awaitDuplicate:'Awaiting Check',
    },
    message: {
        poster: 'The form of the presentation cannot be changed after it is determined, please choose carefully.',
        isCac: 'Please upload your poster presentation',
        posterMes: 'Please upload poster!',
        postermessage: 'please prepare a PPT for the presentation. The specific meeting schedule will be notified separately.',
        poster949message: 'Oral presentations for this conference are scheduled to take place on November 1. Each paper will be allocated approximately 10 minutes for presentation. Should you elect this format, please kindly confirm that the proposed timing is acceptable. The detailed schedule will be communicated to you by a designated staff member at a later date.',
        picSize:'The recommended size of the uploaded image: 1900px*2700px, <=10MB.',
        picSize2:'The recommended size of the uploaded image: {size}, <=10MB.',
        certificatePro: 'You have no certificate to view',
        closeMessage: 'close review?',
        detailBackTip: 'Are you sure to return this review opinion',
        prompt: 'prompt',
        finalConfirm: 'It is imperative to complete signing the electronic IEEE Copyright and Consent Form (eCF) before the successful inclusion of the English papers. Before uploading the final draft, please click "Go to sign" to start the signing process.',
        finalConfirm2: 'Please complete the electronic IEEE Copyright Form (eCF)  signing before submitting the final paper, click Go Signing to start the eCF signing.',
        chooseReviewer2: 'The data has been selected',
        chooseReviewer1: 'The reviewer and the author may be in the same unit, are they still assigned?',
        ecopyrightTip: 'Once signing completed, be sure to click the "Done" button as the final step to return to the submission system. <br/>Click "OK" to jump to the IEEE copyright signing page.',
        EcopyrightNo: 'The Signing Function of the Ecopyright  Agreement has not been opened yet, please try again later or pay attention to the latest notice on the official website.',
        IsChinesePdf:'The PDF content is detected as ',
        IsChinesePdf1:'The PDF detected may be ',
        IsChinesePdf2:' , please confirm and submit!',
        finalUploadCheck:"Please register and pay the fee before submitting the final paper.",
        statusAndId:"Please select paper status or paper ID."
    },
    summary: {
        day: 'day',
        status: {
            text: 'Paper Status',
            subtext: 'Each status of paper',
            series: 'Visit source'
        },
        trend: 'Paper Trend',
        trend2: 'Number of reviewers change statistics',
        cochair: {
            text: 'Cochair',
            subtext: 'Cochair of users',
            other: 'Other Count',
            series: 'Visit source'
        },
        reviewer: {
            text: 'Reviewer',
            subtext: 'Reviewer of users',
            other: 'Other Count',
            series: 'Visit source'
        },
        // copyright提交统计
        reviewer2: {
            text: 'Copyright',
            subtext: 'Copyright Submit statistical',
            series: 'Submit the number'
        },
        reviewer3: {
            text: 'Final',
            subtext: 'Final submission statistics',
            series: 'Submit the number'
        },
        tableData: {
            text: 'Contribution statistics',
            subtext: 'Statistics of contribution volume of each Topic',
            name: 'topic',
            count: 'count',
            total: 'total'
        },
        tableData1: {
            text: 'Quantity statistics of papers',
            subtext: 'Statistics on the number of group papers in each institution',
            name: 'organization',
            count: 'count',
            total: 'total'
        },
        tableData2: {
            text: 'Regional statistics of country',
            subtext: 'Statistics of the number of papers in each region',
            name: 'Country',
            count: 'count',
            total: 'total'
        },
        //日志
        OperateLog: {
            id: 'ID',
            paperId: 'paperId',
            operDesc: 'operDesc',
            operTime: 'operTime'
        }
    },
    copyrightSubmission: {
        title: 'Copyright Submission',
        PubTitle: 'PubTitle',
        ArtTitle: 'ArtTitle',
        AuthName: 'AuthName',
        ArtId: 'ArtId',
        ArtSource: 'ArtSource',
        ArtEmail: 'ArtEmail',
        rtrnurl: 'rtrnurl'
    },
    paper: {
        address: 'Address',
        showTime: 'Time',
        boardCode: 'Board Code', //展板编号
        printSize: 'Poster print size', //海报打印标准尺寸
        Nopayment: 'No payment',
        Underreview: 'Under review',
        Paymentsuccess: 'Payment success',
        successornot: 'Payment success & Not completed',
        Applyrefund: 'Apply refund',
        Fefunded: 'Fefunded',
        NoRegister: 'No Register',
        registerStatus: 'Register Status',
        yes: 'Yes',
        no: 'No',
        copyrightSubmission: 'Copyright Submission',
        paperCount: 'paper count',
        whiteTitle: 'The Submission is closed.',
        titles: 'ID、title、author、email、organization',
        id: 'Paper ID',
        title: 'Paper Title',
        student: 'If Student',
        language: 'Language',
        topic: 'Topic',
        session: 'Session(optional)',
        invitationCode: 'InvitationCode',
        presentationType: 'Presentation Type',
        OnlinePresentation: 'Online presentation (reserved for exceptional circumstances only)',
        onlineTag: 'Online Tag',
        
        // presentationTypeNode: 'Please select your intended way of paper presentation. The CAC affairs team will refer to the paper intention and schedule to arrange the paper presentation, and finally the official website of the CAC shall prevail.',
        presentationTypeNode: 'Please choose the method of paper presentation. The conference organizing committee will arrange the paper presentation according to your preference and the schedule. The final presentation method will be announced on the official website.',
        status: 'Status',
        reviewerd: 'Reviewerd>=',
        ifIntoSet: 'If In The Set',
        operation: 'Operation',
        cochair: 'Cochair',
        cochairId: 'Cochair ID',
        reviewerId: 'Reviewer ID',
        review: 'Review',
        paperOperate: 'Operate',
        paperOperateTitle: 'Papers Which You Need Operate',
        paperJudge: 'Judge',
        paperJudgeTitle: 'Papers Which You Need Judge',
        paperSession: 'Session',
        paperSessionTitle: 'Papers Which Have No Session',
        paperCochair: 'Cochair Operate',
        paperCochairTitle: 'Papers Which Cochair Operate',
        paperAllTitle: 'All Papers',
        submitUser: 'Submit User',
        submitUserEmail: 'Submit User Email',
        submitUserPhone: 'Submit User Phone',
        keywords: 'Keywords',
        abstract: 'Paper Abstract',
        file: 'Paper File',
        comment: 'Comment',
        author: 'Author',
        reader: 'Reviewer',
        number: 'Number',
        authorId: 'Author ID',
        authorSalutation: 'Salutation',
        authorName: 'Author Name',
        authorOrganization: 'Organization',
        authorCountry: 'Country',
        authorEmail: 'Author Email',
        authorEmailMessage: 'Please enter a valid email address',
        authorEmailSpaceMessage: 'Email address cannot contain spaces.',
        evaluateType: 'Evaluate Type',
        recommendType: 'Recommend Type',
        ifBest: 'Recommend as a Best Paper candidate',
        bestReason: 'Recommended Reason',
        reviewComment: 'Comment',
        organizationRate: 'organization(poor-->excellent)',
        organizationRateArr: ['poor', 'bad', 'medium', 'good', 'excellent'],
        clarityRate: 'clarity(low-->high)',
        clarityRateArr: ['low', 'slightly low', 'medium', 'slightly high', 'high'],
        lengthRate: 'length(long-->short)',
        lengthRateArr: ['long', 'slightly long', 'medium', 'slightly short', 'short'],
        referencesRate: 'references(incomplete--> adequate)',
        referencesRateArr: ['incomplete', 'partly incomplete', 'medium', 'slightly adequate', 'adequate'],
        correctnessRate: 'correctness(incorrect-->correct)',
        correctnessRateArr: ['incorrect', 'partly incorrect', 'medium', 'slightly correct', 'correct'],
        significanceRate: 'significance(low-->high)',
        significanceRateArr: ['low', 'slightly low', 'medium', 'slightly high', 'high'],
        originalityRate: 'originality(low-->high)',
        originalityRateArr: ['low', 'slightly low', 'medium', 'slightly high', 'high'],
        surveyCoverageRate: 'surveyCoverage(shallow-->broad)',
        surveyCoverageRateArr: ['shallow', 'a bit shallow', 'medium', 'a bit broad', 'broad'],
        contributionRate: 'contribution(no new results-->significant)',
        contributionRateArr: ['no new results', 'a little results', 'medium', 'a little significant', 'significant'],
        contributionDetail: 'What are the contributions of the paper?',
        improveMethods: 'What are the additional ways in which the paper could be improved?',
        reviewerNums: 'ReviewerNums',
        totalReviewerNums: 'totalReviewerNums',
        finishReviewerNums: 'finishReviewerNums',
        cochairJudge: 'CochairJudge',
        ifPass: 'If Pass',
        CochairIfPass: 'Cochair If Pass',
        CochairIfBest: 'Cochair Recommend as a Best Paper candidate',
        CochairBestReason: 'Cochair Recommended Reason',
        Remark: 'Comment',
        CochairRemark: 'Cochair Comment',
        Reviewers: 'Reviewers',
        reviewerLeast: 'Reviewer(at least ',
        reviewerLeastLast: ' )',
        name: 'Name',
        email: 'Email',
        ifActive: 'If Active',
        inviteStatus: 'Invite Status',
        chooseReviewer: 'Choose Reviewer',
        download: 'Download',
        downloadFinal: 'Final-Download',
        setId: 'ID',
        copyright: 'Copyright',
        packDownload: 'Pack Download',
        paperType: 'Paper Type',
        paper: 'Paper',
        summary: 'Summary',
        uploadTip: 'Please upload PDF documents',
        uploadTipDoc: 'Please upload doc、docx documents',
        uploadTipZip: 'Please upload rar、zip documents',
        rule: {
            submitUserId: 'Please choose Submit User',
            paperTitle: 'Please input paper title',
            keywords: 'Please input keywords',
            paperAbstract: 'Please input paper abstract',
            filePath: 'Please upload paper file',
            ifStudent: 'Please choose is it a student',
            language: 'Please choose language',
            topicList: 'Please choose topic',
            paperType: 'Please choose paper type',
            presentationType: 'Please choose presentation type',
            authorList: 'Please input author',
            author: {
                salutationId: 'Please input author salutation',
                name: 'Please input author name',
                organization: 'Please input choose organization',
                country: 'Please choose author country',
                email: 'Please input author email'
            },
            paper: 'Please choose paper',
            user: 'Please choose user',
            review: 'Please input review',
            session: 'Please choose session',
            ifPass: 'Please choose if pass',
            evaluateType: 'Please Choose evaluate type',
            recommendType: 'Please Choose recommend type',
            ifBest: 'Please Choose Recommend as a Best Paper candidate',
            bestReason: 'Please Choose Recommended Reason'

        },
        confirm: {
            question: 'Do you confirm the creation of paper set?',
            notice: 'Please input copyright',
            certain: 'Confirm',
            cancel: 'Cancel',
            codeValid: 'Please input copyright'
        },
        deleteTip: 'Are you sure delete paper',
        count: 'Paper Count',
        ai: {
            uploadBotton: 'Click Upload ', //后面空格别动，有用
            title: 'Submission Assistant',
            // content: "We recommend using the Submission Assistant's auto-fill feature, allowing AI to help you complete the form.",
            content: "Recommend using the submission assistant's auto-fill feature to let AI help you pre-fill forms.",
            content2: "(Please note that AI can make mistakes, so be sure to check the automatically generated content carefully.)",
            paperPdf: 'Paper PDF',
            select: 'Select',
            oneClick: 'One-click Fill',
            cancel: 'Cancel',
            time: 'Parsed for {sec} seconds, in progress',
            timeOut: 'Parsed for {sec} seconds, completed',
            selectFile: 'Select File',
            timeError: 'Parsing failed, please re-upload',
            faildUpload: 'File upload failed, please re-upload',
            pleaseSelect: 'Please select a file to upload',
            noValidData: 'No valid data detected, please check and re-upload',
            fileAlready: 'Uploaded file already exists, please remove and re-upload',
        }
    },
    email: {
        SendTimeStart: 'SendTime Start',
        SendTimeEnd: 'SendTime End',
        id: 'Email ID',
        paperIds: 'Paper ID',
        subject: 'Subject',
        fromEmail: 'From Email',
        toEmail: 'To Email',
        template: 'Template',
        status: 'Email Status',
        operation: 'Operation',
        content: 'Content',
        success: 'If Success',
        emailStatus: 'Send Status',
        createTime: 'Create Time',
        sendTime: 'Send Time',
        latestSendTime: 'Latest Send Time',
        paperStatus: 'Paper Status',
        receiver: 'Receiver',
        ScreeningEmail:'Filter by author',
        filterPaper:'Filter by paper',
        rule: {
            userIdList: 'Please choose email receiver',
            subject: 'Please input email subject',
            cond1: 'Please select',
            paperStatus: 'Please select paper status',
            receiver: 'Please select receiver',
            content: 'Please input email content'
        },
        deleteTip: 'Are you sure delete email',
        Revieweremail: 'Reviewer Eail',
        invitationstatus: 'Invitation Status',
        Waiting: 'Waiting',
        InvitationDate: 'Invitation Date',

        Accepted: 'Accept_Invitation',
        Rejected: 'Reject_Invitation',
        // Accepted: 'Accepted',
        // Rejected: 'Rejected',
        Reviewed: 'Reviewed',
        Back: 'Back',
        Sending: 'Sending',
        Success: 'Success',
        Fail: 'Fail',
        DeliverSuccess: 'DeliverSuccess',
        DeliverFail: 'DeliverFail',
        ResendMail: 'Resend Mail',
        Resend: 'Resend',
    },
    emailT: {
        id: 'Template ID',
        title: 'Template Title',
        operation: 'Operation',
        content: 'Content',
        ifSystem: 'If System',
        normalT: 'Normal',
        systemT: 'System',
        description: 'Description',
        rule: {
            title: 'Please input email template title',
            content: 'Please input email template content',
            ifSystem: 'Please choose if it is a system templete '
        },
        deleteTip: 'Are you sure delete email template'
    },
    session: {
        id: 'Session ID',
        title: 'Session Title',
        type: 'Session Type',
        place: 'Place',
        operation: 'Operation',
        abstract: 'Session Abstract',
        rule: {
            title: 'Please input session title',
            type: 'Please choose session type',
            place: 'Please input session place'
        },
        deleteTip: 'Are you sure delete session'
    },
    topic: {
        id: 'Topic ID',
        title: 'Topic Title',
        en: 'Topic English',
        operation: 'Operation',
        rule: {
            title: 'Please input topic title',
            en: 'Please input topic english'
        },
        deleteTip: 'Are you sure delete topic'
    },
    user: {
        id: 'User ID',
        loginName: 'LoginName',
        salutationName: 'Salutation',
        email: 'User Email',
        emailStandby: 'Standby Email',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        suffix: 'Suffix',
        institution: 'Institution',
        department: 'Department',
        address: 'Address',
        addressStandby: 'Standby Address',
        country: 'Country',
        province: 'Province',
        city: 'City',
        postalCode: 'Postalcode',
        phone: 'Phone',
        fax: 'Fax',
        professionalField: 'Professional Field',
        operation: 'Operation',
        roles: 'User Roles',
        role: 'Role',
        deleteTip: 'Are you sure delete user'
    },
    cochair: {
        id: 'Cochair ID',
        userName: 'User Name',
        realName: 'Real Name',
        password: 'Password',
        passwordConfirm: 'Password Confirm',
        email: 'Email',
        operation: 'Operation',
        rule: {
            userName: 'Please input user name',
            realName: 'Please input real name',
            password: 'Please input password',
            passwordConfirm: 'Please input confirm password',
            passwordNotEqual: 'Confirm password is not equal to password',
            email: 'Please input email'
        },
        deleteTip: 'Are you sure delete cochair'
    },
    invitationJudges: {
        title: 'Reviewer Invite',
        userName: 'name',
        department: 'institution',
        phone1: 'mobile',
        phone: 'mobile(The default password for new registered users is mobile phone number)',
        email: 'email',
        status: 'status',
        jobTitle: 'jobTitle',
        reviewerResearch: 'reviewerResearch',
        userNameMesage: 'Please enter the name',
        departmentMesage: 'Please enter the institution',
        phoneMesage: 'The phone is required',
        emailMesage: 'The email address is required',

        mobile2: 'Please enter the correct phone number',
        mobile3: 'The phone is registered,Please click the link at the bottom to log in!',
        email2: 'Please enter the correct email address',
        email3: 'The Email is registered,Please click the link at the bottom to log in!',
        loginIn: "Registered user, please log in!",
        jobTitleMesage: 'Please enter the title',
        topicMesage: 'Please enter the topic',
        add: 'add',
        reviewerResearchMesage: 'Please add at least one research direction',
        message1: 'You have successfully applied, waiting for review!',
        message2: 'Your application has been approved. Please pay attention to the email and accept the invitation to review your paper.',
        message3: 'Your application has been rejected!',
        message4: 'Filling out is finished!',
        prompt: 'prompt',
        message: 'This audit operation cannot be modified. Do you want to continue?',
        submit: 'submit',
        submit1: 'submit',
        ok: 'OK',
        reapply: 'reapply',
        cancel: 'cancel',
        Operation: 'Operation is successful!',
        info: 'Cancel the operation!'
    }
}



// WEBPACK FOOTER //
// ./src/lang/en.js